import { useEffect } from "react";
import { createPortal } from "react-dom";

/**
 * Pinta su contenido directo en <body>, fuera de cualquier contenedor con
 * animación o transform. Así una ventana con position: fixed siempre queda
 * centrada en la pantalla, sin importar el scroll.
 *
 * - Bloquea el scroll de la página mientras está abierto.
 * - Llama a onClose al presionar Esc (si se pasa).
 *
 * Uso:
 *   {abierto && (
 *     <ModalPortal onClose={cerrar}>
 *       <div className="modal-overlay" onClick={cerrar}>...</div>
 *     </ModalPortal>
 *   )}
 */
export default function ModalPortal({ children, onClose }) {
  useEffect(() => {
    const previo = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKey = (e) => { if (e.key === "Escape" && onClose) onClose(); };
    window.addEventListener("keydown", onKey);

    return () => {
      document.body.style.overflow = previo;
      window.removeEventListener("keydown", onKey);
    };
  }, [onClose]);

  return createPortal(children, document.body);
}
